const ENTERPRISE_NVQUAL_VERSION_PREFIX = 'vG.'

const ERROR_INFO = [
  'errorType',
  'classification',
  'info',
  'filePath',
  'fileLine'
]

const NVQUAL_TESTS = [
  'thermal_qual_test',
  'thermal_qual_test_cpu',
  'bluefield_thermal_test',
  'pcie_qual_test',
  'pcie_bandwidth_test',
  'pcie_peer_to_peer_test',
  'input_edp_test',  
  'nvlink_bandwidth_test',
  'nvlink_qual_test',
  'nvlink_data_eye_test',
  'pcie_data_eye_test',
  'cpu_nvlink_qualification_test',
  'gpu_nvlink_qualification_test',
  'cx7_pcie_test',
  'grace_rx_pcie_eom_test',
  'ssd_fio_test',
  'bluefield_eye_margin_test',
  'bluefield_thermal_test',
  'bluefield_pcie_interface_traffic_test',
  'cx7_thermal_test',
  'secondary_bus_reset_test',
  'equalization_test',
  'disable_and_enable_link_test',
  'pcie_link_retrain_test',
  'aer_error_check_test',
  'speed_change_test',
  'l1_power_management_test',
  'd3_power_management_test',
  'cpu_qualification_test',
  'memory_qualification_test'
]

const NVQUAL_TEST_CATEGORIES = [
  'Thermal Qualification',
  'Power Qualification',
  'NVLink Qualification',
  'PCIE Qualification',
  'Storage Qualification',
  'CPU Qualification',
  'PCIE Link Training'
]

const CUSTOMER_INPUTS = {
  overview: [
    'productSku',
    'productBrand',
    'nvqualVersion',
    'operatingSystem',
    'cpu',
    'memory',
    'pcieSwitches',
    'submissionDate',
    'projectName',
    'partner',
    'odm',
    'systemModelName'
  ],
  input_edp_test: [
    'inputVoltage54V',
    'inputVoltageMaxAcNoise'
  ],
  thermal_qual_test: [
    'airFlowDesignPoint',
    'airFlowMeasured',
    'liquidTemperature',
    'liquidFlowRate',
    'inletSide',
    'fanConfiguration',
    'numberOfSystemFans',
    'chassisInletAmbientTemperature',
    'externalAmbientTemperature',
    'maximumInletTemperature',
    'airflowMeasurementPoint',
    'flowRateMeasuredOrEstimated',
    'ifMeasuredHow',
    'criticalComponentTemperatureMeasurements',
    'systemFansPwm',
    'systemFansPwmMax',
    'maxPex88000Temp',
    'maxPex8725Temp',
    'maxFpgaTemp',
    'maxNvswitchVrmTemp',
  ]
}

export {
  ENTERPRISE_NVQUAL_VERSION_PREFIX,
  ERROR_INFO,
  NVQUAL_TESTS,
  NVQUAL_TEST_CATEGORIES,
  CUSTOMER_INPUTS
}
